import RolesTable from './RolesTableContainer';

export default RolesTable;
